<template>
  <div class="baselevel-modification">
    <img class="delete-cross" @click="deleteModification" src="../../assets/images/delete-cross.png" />
    <l-map class="baselevel-map" :ref="mapID" @ready="onMapReady" :options="mapOptions"> </l-map>
    <table>
      <tr>
        <td>
          <label :for="levelID">{{ $t('scenario.level') }}:</label>
        </td>
        <td>
          <select :name="levelID" v-model="level" @change="updateAvailabilityLayer">
            <option value="4">{{ $t('scenario.pipe_drainage') }}</option>
            <option value="3">{{ $t('scenario.tertiary') }}</option>
            <option value="2">{{ $t('scenario.secondary') }}</option>
            <option value="1">{{ $t('scenario.primary') }}</option>
          </select>
        </td>
      </tr>
      <tr>
        <td>
          <label :for="operatorID">{{ $t('scenario.operation') }}:</label>
        </td>
        <td>
          <select :name="operatorID" v-model="operator">
            <option value="+">+</option>
            <option value="-">-</option>
            <option value="=">=</option>
          </select>
          <input type="number" :name="valueID" v-model.number="value" step="any">
          <span v-if="modification.operator == '='">mNAP</span><span v-else>m</span>
        </td>
      </tr>
    </table>
  </div>
</template>


<script>
  import { mapMutations } from 'vuex';
  import "leaflet/dist/leaflet.css";
  import "leaflet-draw/dist/leaflet.draw.css";
  import L from 'leaflet';
  import { LMap } from 'vue2-leaflet';
  import 'leaflet-draw';
  import togeojson from 'togeojson';
  import fileLayer from 'leaflet-filelayer';
  fileLayer(null, L, togeojson);  // https://github.com/makinacorpus/Leaflet.FileLayer/issues/60#issuecomment-438757995

  export default {
    name: 'baseLevelModification',
    props: ['modification'],
    data () {
      return {
        map: null,
        mapOptions: {
          zoomControl: false,
        },
        availabilityLayers: []
      }
    },
    computed: {
      mapID() {
        return 'map-' + this.modification.id;
      },
      levelID() {
        return 'level-' + this.modification.id;
      },
      operatorID() {
        return 'operator-' + this.modification.id;
      },
      valueID() {
        return 'value-' + this.modification.id;
      },
      level: {
        get() {return this.modification.level;},
        set(value) {this.setModification('level', value);}
      },
      operator: {
        get() {return this.modification.operator;},
        set(value) {this.setModification('operator', value);}
      },
      value: {
        get() {return this.modification.value;},
        set(value) {this.setModification('value', value);}
      },
    },
    methods: {
      ...mapMutations('scenarioState', ['updateModification']),
      setModification(key, value) {
        this.updateModification({
          modificationType: 'baseLevel',
          id: this.modification.id,
          key: key,
          value: value
        });
      },
      deleteModification() {
        this.$emit('delete-modification', this.modification.id);
      },
      updateAvailabilityLayer() {
        this.availabilityLayers.forEach(layer => this.map.removeLayer(layer));
        const index = this.level - 1;
        this.map.addLayer(this.availabilityLayers[index]);
      },
      availabilityLayer(layer) {
        let params = {
          layers: layer,
          format: 'image/png',
          transparent: true,
          opacity: 0.2,
          useCache: true,
          crossOrigin: true
        }
        return L.tileLayer.wms('https://gis.acaciadata.com/?map=/project/wdod_kelp/wdod.qgz', params);
      },
      onMapReady() {
        this.map = this.$refs[this.mapID].mapObject;
        this.map.attributionControl.setPrefix('<a href="https://leafletjs.com" title="A JavaScript library for interactive maps"> Leaflet</a>');
        this.map.addLayer(
          L.tileLayer(
            "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", 
            {attribution: "&copy; <a target='_blank' href='http://osm.org/copyright'>OpenStreetMap</a> contributors",}
        ));
        this.map.setView([52.56, 6.25], 9);
        this.availabilityLayers = [
          this.availabilityLayer('c1_available'),
          this.availabilityLayer('c2_available'),
          this.availabilityLayer('c3_available'),
          this.availabilityLayer('c4_available')
        ];
        this.updateAvailabilityLayer();

        var drawnItems = this.modification.layer;
        this.map.addLayer(drawnItems);
        var drawControl = new L.Control.Draw({
            position: 'bottomleft',
            edit: {
              featureGroup: drawnItems,
              poly: {
                  allowIntersection: false
              }
            },
            draw: {
              polyline: false,
              circle: false,
              circlemarker: false,
              marker: false,
              rectangle: false,
              polygon: {
                allowIntersection: false,
                shapeOptions: {
                  color: '#00008c',
                  weight: 3,
                  fillOpacity: 0.25
                }
              },
            }
        });
        this.map.addControl(drawControl);
        this.map.on(L.Draw.Event.CREATED, function (event) {
          var layer = event.layer;
          drawnItems.addLayer(layer);
        });

        // File upload control:
        var control = L.Control.fileLayerLoad({
            fileSizeLimit: 10*1024,
            formats: ['.geojson', '.kml']
        });
        control.addTo(this.map);
        control.loader.on('data:loaded', function (event) {
          event.layer.editing = {enable: function() {}, disable: function() {}};    // To avoid an exception.
          drawnItems.addLayer(event.layer);
        });
      },
    },
    components: {
      LMap
    },
  }
</script>


<style scoped>
  .baselevel-modification {
    border: solid black 1px;
    border-top: solid #00008c 30px;
    border-radius: 5px;
    margin-bottom: 10px;
  }
  .baselevel-modification label {
    margin: 3px 10px;
  }
  .baselevel-modification input {
    height: 30px;
    width: 100px;
    margin: 3px;
  }
  .delete-cross {
    float: right;
    width: 18px;
    height: 24px;
    margin-top: -27px;
    margin-right: 3px;
  }
  .baselevel-map {
    height: 500px;
  }
</style>
